export const DROPDOWN_WRAPPER_CLASS_NAME = "countries_and_regions_dd";
export const DROPDOWN_BUTTON = "si.lead_gen_filters.countries.dd_placeholder";
export const DROPDOWN_PLACEHOLDER = "si.lead_gen_filters.companyHeadquarter.dd_placeholder";

export const STATES_DROPDOWN_BUTTON = "si.lead_gen_filters.companyHeadquarter.states_dd_button.text";
export const STATES_DROPDOWN_PLACEHOLDER = "si.lead_gen_filters.companyHeadquarter.states_dd_placeholder";

export const ZIP_CODES_PLACEHOLDER = "si.lead_gen_filters.companyHeadquarter.zip_code_placeholder";
export const ZIP_CODES_BULK_TRANSLATION_PREFIX = "si.lead_gen_filters.companyHeadquarter.codes.bulkAdd";
